import {
	amber,
	blue,
	brown,
	crimson,
	cyan,
	gold,
	grass,
	gray,
	indigo,
	iris,
	jade,
	lime,
	mint,
	orange,
	pink,
	plum,
	purple,
	red,
	sky,
	violet,
	yellow,
} from "@radix-ui/colors"

// Colors used for color selection purposes
export const Colors = {
	indigo: indigo.indigo9,
	red: red.red9,
	yellow: yellow.yellow9,
	gray: gray.gray9,
	purple: purple.purple9,
	orange: orange.orange9,
	pink: pink.pink9,
	gold: gold.gold9,
	brown: brown.brown9,
	amber: amber.amber9,
	crimson: crimson.crimson9,
	plum: plum.plum9,
	violet: violet.violet9,
	iris: iris.iris9,
	blue: blue.blue9,
	cyan: cyan.cyan9,
	jade: jade.jade9,
	grass: grass.grass9,
	lime: lime.lime9,
	mint: mint.mint9,
	sky: sky.sky9,
}

export const colors = Object.values(Colors)

export function getPriorityStageColor(index: number) {
	return Object.values(Colors)[index % Object.keys(Colors).length]
}
